import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, inject, input, resource } from "@angular/core";

import { AlertsService } from "../../../../../../apis/networkdashboard/rest/services";

@Component({
  selector: "devices-section",
  templateUrl: "devices-section.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, TranslatePipe],
})
export class DevicesSection {
  private readonly alertsService = inject(AlertsService);

  protected readonly subscriptionId = input.required<string>();

  protected readonly devices = resource<string[], { subscriptionId: string }>({
    params: () => ({ subscriptionId: this.subscriptionId() }),
    loader: ({ params }) =>
      this.alertsService.getDevicesForSubscriptionFromGrafana({ subscription_id: params.subscriptionId }),
  });

  protected readonly hasDevices = computed(() => !!this.devices.value()?.length);
}
